<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

.br_toolbar_div {
    padding-left: 16px;
}

</style>

<template>
<div>
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="in"
        class="elevation-1"
        @dblclick:row="on_dbl_click">

        <template v-slot:top>
            <nat11_map_box v-model="show_nat1to1_map_box"
                @canceled="nat11_map_box_on_cancel" 
                @selected="nat11_map_box_on_select($event)">
            </nat11_map_box>


            <v-toolbar flat>
                <v-toolbar-title><h2 class="br">NAT44 1:1 translation rules</h2></v-toolbar-title>

                <v-dialog v-model="dialog" max-width="600px">

                    <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                        <v-card-title>
                            <span class="headline">{{ edit_caption }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container style="height: 520px; overflow-y: scroll;">
                                <v-row>

                            <v-col cols="12">
                                <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                                    <v-text-field
                                        v-bind:readonly="edited_index != -1"
                                        v-model="edited_item.int_addr"
                                        label="Internal ipv4 address"
                                    ></v-text-field>
                                    <span class="required_err">{{ errors[0] }}</span>
                                </ValidationProvider> 

                                <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                                    <v-text-field
                                        v-bind:readonly="edited_index != -1"
                                        v-model="edited_item.taddr"
                                        label="Translated ipv4 address"
                                    ></v-text-field>
                                    <span class="required_err">{{ errors[0] }}</span>
                                </ValidationProvider>   
                            </v-col>

                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn v-if="edited_index == -1" color="blue darken-1"
                                text @click="close">Cancel</v-btn>
                            <v-btn v-if="edited_index == -1" color="blue darken-1" 
                                :disabled="invalid" text @click="save">Save</v-btn>
                            <v-btn v-if="edited_index !== -1" color="blue darken-1" 
                                text @click="close">Close</v-btn>
                        </v-card-actions>
                    </v-form></v-card></ValidationObserver>
                </v-dialog>                
            </v-toolbar>
                
            <ValidationObserver ref="observer_prms" v-slot="{ invalid }">
                <div class="br_toolbar_div">
                    <ValidationProvider rules="required|numeric" v-slot="{ errors }">
                        <v-text-field
                            v-model="map_id"
                            label="Map id">
                            <template #append>
                                <v-btn @click="open_nat11_map_box()">...</v-btn>
                            </template>
                        </v-text-field>
                        <span class="required_err">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>

                <div class="br_toolbar_div">
                    <v-btn @click="show"
                            color="primary" class="mb-2"
                            :disabled="invalid">
                            Show rules
                    </v-btn>
                    <v-btn @click="add_rule"
                            color="primary" class="mb-2"
                            :disabled="invalid">
                            Add new rule
                    </v-btn>
                </div>
            </ValidationObserver>

            <v-toolbar flat>
                <v-text-field v-model="search"
                    append-icon="mdi-magnify" label="Search" single-line hide-details
                ></v-text-field>
            </v-toolbar>
        </template>

        <template v-slot:item.actions="{ item }">
            <v-icon small class="me-2" @click="edit_item(item)">
                mdi-pencil
            </v-icon>
            <v-icon small @click="delete_item(item)">
                mdi-delete
            </v-icon>
        </template>

        <template v-slot:no-data>
            no records
        </template>
    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import nat11_map_box from "../components/nat11_map_box.vue";
nat11_map_box
import "../validation_rules.js";

export default {
name: "nat11_trans_rules",
components: { 
    Treeselect, ValidationProvider, ValidationObserver, nat11_map_box,
},
data: () => ({
    show_nat1to1_map_box: false,
    edited_index: -1,
    dialog: false,
    map_id: '',
    search: '',

    edited_item: {
    },
    default_item: {
        int_addr: '',
        taddr: '',
    },

    headers: [
        { text: 'Internal address', value: 'int_addr', align: 'start' },
        { text: 'Translated address', value: 'taddr' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    items: [],
}),


methods: {
    show() {
        return new Promise((resolve, reject) => {
            let data = {
                map_id: this.map_id,
            };
            api_client.run_post_query('/nat/snat1to1/show_trans_rules', data)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.items = response.data;
                }
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    edit_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.edit_caption = 'NAT11 map ' + this.map_id + ' translation rule';
        this.dialog = true;
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    add_rule() {
        this.edit_caption = 'NAT11 map ' + this.map_id + ' new translation rule';
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.dialog = true;
    },

    save() {
        api_client.run_post_query('/nat/snat1to1/add_trans_rule', {
            map_id: this.map_id,
            int_addr: this.edited_item.int_addr,
            taddr: this.edited_item.taddr,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.show();
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });        
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete translation rule " + 
             this.edited_item.int_addr + " -> " +  this.edited_item.taddr + " ?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.run_post_query('/nat/snat1to1/del_trans_rule', {
            map_id: this.map_id,
            int_addr: this.edited_item.int_addr,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                this.items.splice(this.edited_index, 1);
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    open_nat11_map_box() {
        this.show_nat1to1_map_box = true;
    },
    
    nat11_map_box_on_cancel() {
        this.show_nat1to1_map_box = false;
    },

    nat11_map_box_on_select(map_id) {
        this.map_id = map_id;
        this.nat11_map_box_on_cancel();
    },    
}

};
</script>
